import Voucher from '../../../../components/Voucher';

const B2BVoucher = (props) => {
	const { b2bVoucherList, remainingNominal, handleVoucherDetail, setDataVoucherWarning, setIsShowWarningVoucher, handleUpdateVoucherList } = props;
	return (
		<>
			{b2bVoucherList?.map((voucher, index) => {
				return (
					<Voucher
						key={`b2b_voucher_all_${index}`}
						showLabelCount={false}
						type={'b2b_voucher'}
						data={voucher}
						handleUseVoucher={(data, type, warning) => {
							if (warning && type === "plus") {
								setDataVoucherWarning({
									code: data.code,
									voucher_type: 'b2b_voucher',
									is_use: data.is_use ?? false,
									type: type,
								});
								setIsShowWarningVoucher(true);
							} else {
								handleUpdateVoucherList(data.code, 'b2b_voucher', data.is_use ?? false, type);
							}
						}}
						remainingNominal={remainingNominal}
						onOpenDetail={() => handleVoucherDetail(true, voucher)}
					/>
				);
			})}
		</>
	);
};

export default B2BVoucher;
